import { withChartLayout } from 'components/common';
import ObstetricAssessment from 'components/features/chart/system-assessment/obstetric-assessment/ObstetricAssessment';

const ObstetricAssessmentPage = withChartLayout('Obstetric Assessment')(ObstetricAssessment);
export default ObstetricAssessmentPage;
